module.exports = __webpack_public_path__ + "static/media/change_new.3c54f33a.png";